export const StatusList = (theme) => {
    return (
        [
            {
                name: 'NotAvailable',
                desc: 'در دسترس نیست',
                value: 0,
                color: theme.white,
            },
            {
                name: 'Available',
                desc: 'در دسترس',
                value: 1,
                color: theme.calendarGreen,
            },
            // {
            //     name: 'BookedByYou',
            //     desc : 'رزرو شده توسط شما',
            //     value: 3,
            //     color: theme.secondary,
            // },
            // {
            //     name: 'BookedByOther',
            //     desc : 'رزور شده توسط دیگزان',
            //     value: 2,
            //     color: theme.white,
            // },

        ]
    )
}